module.exports = __webpack_public_path__ + "static/media/popular_learning_topics_3.e708704f.png";